<template>
	<b-input-group>
		<b-input-group-prepend is-text>
			<font-awesome-icon :icon="loading ? loadingIcon : searchIcon" :spin="loading" />
		</b-input-group-prepend>
		<b-form-input
			type="text"
			ref="formInput"
			v-model="localQuery"
			:autofocus="autofocus"
			:placeholder="placeholder"
			autocomplete="off"
			class="ml-auto"
		/>
	</b-input-group>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
	name: "SearchInput",
	props: {
		autofocus: {
			type: Boolean,
			default: true,
		},
		value: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "Search...",
		},
		loading: {
			type: Boolean,
			default: false,
		},
		loadingIcon: {
			type: String,
			default: "circle-notch",
		},
		searchIcon: {
			type: String,
			default: "search",
		},
	},
	data() {
		return {
			localQuery: this.value,
		};
	},
	watch: {
		localQuery: {
			handler: debounce(function(newValue) {
				this.$emit("input", newValue);
			}, 300),
			immediate: true,
		},
	},
	methods: {
		focus() {
			this.$refs.formInput.focus();
		},
		clear() {
			this.localQuery = "";
		},
	},
};
</script>
